"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// ----------------
// ACTION CREATORS - These are functions exposed to UI components that will trigger a state transition.
// They don't directly mutate state, but they can have external side-effects (such as loading data).
exports.actionCreators = {
    setConfirmationCode: function (cc) { return function (dispatch, getState) {
        dispatch({ type: 'SET_CONFIRMATION_CODE', confirmationCode: cc });
    }; },
    setAccessCode: function (ac) { return function (dispatch, getState) {
        dispatch({ type: 'SET_ACCESS_CODE', accessCode: ac });
    }; },
    setEventID: function (eId) { return function (dispatch, getState) {
        dispatch({ type: 'SET_EVENT_ID', eventId: eId });
    }; },
    getCode: function () { return function (dispatch, getState) {
        dispatch({ type: 'RETRIEVE_CONFIRMATION_CODE' });
    }; },
    getEventId: function () { return function (dispatch, getState) {
        dispatch({ type: 'RETRIEVE_EVENT_ID' });
    }; },
};
// ----------------
// REDUCER - For a given state and action, returns the new state. To support time travel, this must not mutate the old state.
exports.initialState = {
    confirmationCode: "000",
    accessCode: "000",
    eventId: "0",
};
exports.reducer = function (state, incomingAction) {
    if (state === undefined) {
        return state || exports.initialState;
    }
    var action = incomingAction;
    switch (action.type) {
        case 'SET_CONFIRMATION_CODE':
            return { confirmationCode: action.confirmationCode, accessCode: '', eventId: '' };
        case 'RETRIEVE_CONFIRMATION_CODE':
            return { confirmationCode: state.confirmationCode, accessCode: '', eventId: '' };
        case 'RETRIEVE_EVENT_ID':
            return { confirmationCode: '', accessCode: '', eventId: state.eventId };
        case 'SET_ACCESS_CODE':
            return { confirmationCode: '', accessCode: action.accessCode, eventId: '' };
        case 'SET_EVENT_ID':
            return { confirmationCode: '', accessCode: '', eventId: action.eventId };
        default:
            return state;
    }
};
//# sourceMappingURL=Register.js.map